import styled from "styled-components";

interface Props {
    menuOpen?: boolean;
    profileStatus?: any;
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;
    position: relative;
    margin: 0 auto;  
    
    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 50%;
        margin-top: 200px;
        transform: translateX(-50%);
    }

    .op {
        position: absolute;
        width: fit-content;
        right: 0;
        margin-top: -72px;
        padding: 16px;
        z-index: 1001;
    }

    .zero {
        color: ${({ theme }) => theme.colors.interfaceText400};
        padding-left: 8px;
    }

    @media (max-width: 1000px) {
        min-width: 1200px;
    }
`;

export const Menu = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.interfacePure100};
`

export const TableContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const ApplicantCard = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    box-shadow: 35px 45px 73px rgba(32, 32, 35, 0.07);

    @media (max-width: 1000px) {
        min-width: 1200px;
    }
`;

export const ApplicantWrapper = styled.div<Props>`
    display: flex;
    flex-direction: column;    
    width: 100%;
    height: ${({ menuOpen }) => (menuOpen ? "160px" : "80px")};    
    background: ${({ theme }) => theme.colors.interfacePure0};
    border-radius: 8px;     
    
    .title {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 4px;
    }

    .subtitle {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 14px;
        font-weight: 500;
    }
`;

export const ApplicantTop = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 80px;
    padding-left: 24px;
    padding-right: 16px;
    padding-top: 16px;
`;

export const ApplicantBottom = styled.div<Props>`
    display: ${({ menuOpen }) => (menuOpen ? "flex" : "none")};
    align-items: flex-start;
    justify-content: flex-start;
    height: 80px;
    padding-left: 24px;
    padding-right: 16px;
    padding-top: 16px;
`;

export const DivIcon = styled.div`
    width: 40px;
    display: flex;
    align-items: flex-start;
    
    svg {
        path {
            fill: ${({ theme }) => theme.colors.interfaceGray300};
        }
    }
`;

export const DivName = styled.div`
    width: 224px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    
    .subtitle {
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
        max-width: 100%;
        hyphens: auto;
    }
    
    .show-name {
        display: none;
        min-width: 500px;
        height: fit-content;
        padding: 12px;
        background: ${(props: any) => props.theme.colors.interfacePure0};
        border: 1px solid ${({ theme }) => theme.colors.primaryRed400};
        border-radius: 8px;
        position: absolute;
        top: 20px;
        left: 0;
        box-shadow: 3px 5px 5px 1px rgba(32,32,35,0.4);
        z-index: 10;

        color: ${({ theme }) => theme.colors.interText400};
        font-size: 14px;
        font-weight: 500;
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
        hyphens: auto;
    }

    &:hover .show-name {
        display: block;
    }
`;

export const DivDocument = styled.div`
    width: 140px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 0px;
`;

export const DivContact = styled.div`
    width: 240px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    .subtitle:not(:last-child) {
        margin-bottom: 2px;
    }
    
    .subtitle:last-child {
        font-size: 12px;
        color: ${({ theme }) => theme.colors.interfaceText300};
    }
`;

export const DivCode = styled.div`
    width: 160px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    .subtitle {
        font-size: 13px;
        line-height: 1.3;
    }
`;

export const DivStatus = styled.div`
    width: 70px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    margin-right: 10px;
    
    .title {
        margin-bottom: 4px;
    }
`;

export const DivAction = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-right: 10px;
    background: var(--action-square-bg);
    border-radius: 8px;
    cursor: pointer;
    
    &.fake {
        background: none;
        cursor: auto;
    }
`;

export const DivArrow = styled.div`
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    cursor: pointer;

    &.fake {
        cursor: auto;
    }
`;

export const StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-transform: capitalize;
    max-width: 80px;
    
    &.success {
        background-color: ${({ theme }) => theme.colors.interfaceSuccess100};
        color: ${({ theme }) => theme.colors.interfaceSuccess400};
    }
    
    &.warning {
        background-color: ${({ theme }) => theme.colors.primaryOrange50};
        color: ${({ theme }) => theme.colors.primaryOrange700};
    }
    
    &.default {
        background-color: ${({ theme }) => theme.colors.interfacePure100};
        color: ${({ theme }) => theme.colors.interfaceText500};
    }
`;

// Remover os estilos antigos que não são mais necessários
export const TableRow = styled.div``;
export const ExpandButton = styled.button``;
export const CollapseContent = styled.div``;

export const DivActionsTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 60px;
`;

export const ReenviarIconButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: var(--action-square-bg);
    border: none;
    color: ${({ theme }) => theme.colors.pureWhite};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: var(--action-square-bg-hover);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;
